import { useMemo } from 'react';

import cn from 'classnames';
import { AdminRoles } from 'constants/permissions';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

import { selectAuthentication } from 'api/authentication-slice';

import styles from './AdminNavbar.module.scss';

const navigationItems = [
  {
    path: '/admin/check_types',
    label: 'Check Types',
    roles: [AdminRoles.SuperAdmin],
  },
  {
    path: '/admin/companies',
    label: 'Companies',
    roles: [AdminRoles.SuperAdmin, AdminRoles.Sales, AdminRoles.Support, AdminRoles.ACIC],
  },
  {
    path: '/admin/dashboard',
    label: 'Dashboard',
    roles: [AdminRoles.Support, AdminRoles.ACIC],
    isPrimary: true,
  },
  {
    path: '/admin/users',
    label: 'Users',
    roles: [AdminRoles.SuperAdmin, AdminRoles.Sales, AdminRoles.Support, AdminRoles.ACIC],
  },
  {
    path: '/admin/candidates',
    label: 'Candidates',
    roles: [AdminRoles.SuperAdmin, AdminRoles.Support, AdminRoles.ACIC],
  },
  {
    path: '/admin/checks',
    label: 'Candidate Checks',
    roles: [AdminRoles.SuperAdmin],
  },
  {
    path: '/admin/reporting',
    label: 'Reporting',
    roles: [AdminRoles.SuperAdmin, AdminRoles.Sales],
  },
  {
    path: '/admin/log',
    label: 'Logs',
    roles: [AdminRoles.SuperAdmin],
  },
  {
    path: '/admin/admin_users',
    label: 'Admin Users',
    roles: [AdminRoles.SuperAdmin],
  },
  {
    path: '/admin/admin_users',
    label: 'Admin Users',
    roles: [AdminRoles.Support],
  },
];

export const AdminNavbar = () => {
  const authentication = useSelector(selectAuthentication);

  const allowedAdminTabs = useMemo(() => {
    if (!authentication.checked) return [];

    const filtered = navigationItems.filter(item => {
      const hasRole = item.roles.includes(authentication.admin_role);
      const isPrimary = item?.isPrimary && authentication.is_primary;
      return hasRole || isPrimary;
    });

    return filtered;
  }, [authentication.checked, authentication.admin_role, authentication.is_primary]);

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <Link to="/dashboard" className={styles.logo}>
          <img
            className={cn(styles.logo, 'u-margin-bottom--0')}
            src="./assets/images/checkmate/icon-label.svg"
            alt="checkmate"
          />
        </Link>
        <div className={cn(styles.hideXS, styles.links)}>
          {allowedAdminTabs.map(item => (
            <NavLink key={item.path} to={item.path}>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};
